import discardReadReceiptOption from './actions/discardReadReceiptOption';
import saveReadReceiptOption from './actions/saveReadReceiptOption';
import ReadReceiptsFull from './components/ReadReceiptsFull';
import isReadReceiptOptionDirty from './utils/isReadReceiptOptionDirty';
import { Option } from 'owa-options-core';
import * as React from 'react';

let ReadReceiptsOption: Option = {
    key: 'readReceipts',
    titleStringKey: 'optionTitle_readReceipts',
    searchTermsStringKey: 'optionTitle_readReceipts',
    fullOptionFormSettings: {
        render: () => <ReadReceiptsFull />,
        isDirty: isReadReceiptOptionDirty,
        onSave: saveReadReceiptOption,
        onDiscard: discardReadReceiptOption,
    },
    allowedOptionKeys: ['ReadReceipts'],
};

export default ReadReceiptsOption;
